import React from 'react';
import { withTheme } from 'glamorous';
import { Button } from '../../../../common/components';
import HR from '../HorizontalRule';
import { TitleBar } from '../../../../common/components/Layout/StandardPageTemplate/Context';
import BaseSettingsPage from '../BaseSettingsPage';
import TopicsPage from '../TopicsPage';
import { Tab, Tabs } from 'react-toolbox/lib/tabs';
import tabsTheme from './Tabs.css';
import styles from './styles.css';

class GetInvolvedPage extends React.Component {
  state = {
    tabIndex: 0,
  };
  saveHandlers = {};

  handleTabChange = tabIndex => {
    this.setState({ tabIndex });
  };

  addSaveHandler = key => func => {
    this.saveHandlers[key] = func;
  };

  handleSave = () => {
    Object.values(this.saveHandlers).forEach(func => {
      func();
    });
  };

  render() {
    const {theme: { colors }} = this.props;

    const pageColor = {
      name: 'green',
      value: colors['green'],
    };

    return (
      <div>
        <TitleBar title={'Get Involved'} />
        <Tabs fixed index={this.state.tabIndex} onChange={this.handleTabChange} theme={tabsTheme}>
          <Tab label="I'm Willing To">
            <BaseSettingsPage category="GetInvolved" pageColor={pageColor} />
          </Tab>
          <Tab label="I Care about">
            <TopicsPage
              renderSubmit={this.addSaveHandler('Interests')}
            />
            <Button
              onClick={this.handleSave}
              label="Save"
              className={styles['save-button']}
            />
          </Tab>
        </Tabs>
        <HR color={pageColor.name} />
        <Button
          to="/account"
          label="Back to Account Management"
        />
      </div>
    );

  }
}

export default withTheme(GetInvolvedPage);



// WEBPACK FOOTER //
// ./src/App/account/components/GetInvolvedPage/index.js